'use client'

import { ProductDetail, ProductDetailMachineProvider } from '@segments/ProductDetail'
import * as React from 'react'

import { CartModalControlsProvider } from '~shared/segments/Cart'
import { ProductDetailProvider } from '~shared/segments/ProductDetail/contexts/ProductDetailProvider'
import { ProductListDataProvider } from '~shared/segments/ProductList'

import { ValidateOrderStatus } from '../../contexts/ValidateOrderStatus/ValidateOrderStatus'
import { MenuScreenResponsiveContent } from './components/MenuScreenResponsiveContent'
import { MenuCartContentProvider } from './contexts/MenuCartContentProvider'
import { ProductListSelectionProvider } from './contexts/ProductListSelectionProvider'
import { useLoadProductList } from './hooks/useLoadProductList'

type TProps = NoChildren

export const MenuScreen: React.FC<TProps> = () => {
  return (
    <ProductListDataProvider useLoadProductList={useLoadProductList}>
      <ProductListSelectionProvider>
        <MenuCartContentProvider>
          <CartModalControlsProvider>
            <ProductDetailProvider>
              <ProductDetailMachineProvider>
                <ValidateOrderStatus />
                <MenuScreenResponsiveContent />

                <ProductDetail />
              </ProductDetailMachineProvider>
            </ProductDetailProvider>
          </CartModalControlsProvider>
        </MenuCartContentProvider>
      </ProductListSelectionProvider>
    </ProductListDataProvider>
  )
}
